exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-scroll{border-radius:8px;padding:20px 20px 5px}.button-blue-alemana{background-color:#407ec9!important;color:#fff!important}", ""]);

// exports
